import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { NovaMatIconRegistryService } from 'src/app/shared/services/mat-icon-registry.service';
import { SanitizerPipe } from './pipes/sanitizer.pipe';
import { MatIconModule } from '@angular/material/icon';
import { NgClass, NgTemplateOutlet } from '@angular/common';

export type ErrorType =
    | 'alert'
    | 'warning'
    | 'error'
    | 'important'
    | 'confirmation'
    | 'info'
    | 'search'
    | 'additionalInfo';

@Component({
    selector: 'nova-banner',
    templateUrl: './banner.component.html',
    styleUrls: ['./banner.component.scss'],
    standalone: true,
    imports: [NgClass, MatIconModule, NgTemplateOutlet, SanitizerPipe]
})
export class BannerComponent implements OnInit {
    @Input()
    bannerMessage =
        'An error occurred. Please try again. If the error continues, contact <a href="mailto:ayait@ayahealthcare.com">ayait@ayahealthcare.com</a> and include the below information.';

    @Input()
    bannerType: ErrorType = 'alert';

    @Input()
    optionTemplate: TemplateRef<any>;

    @Input()
    overrideClass: string;

    @Input()
    messageOverrideClass: string;

    @Input()
    dataQaId: string;

    @Input()
    extendMargin: boolean = false;

    @Input()
    extendHeight: boolean = false;

    @Input()
    hideIcon: boolean = false;

    @Input()
    closeEnabled: boolean = false;

    @Output()
    close = new EventEmitter<void>();

    public showBanner = true;

    bannerIcons = {
        alert: 'sentiment_very_dissatisfied',
        warning: 'surprised',
        important: 'pointRight',
        error: 'error',
        confirmation: 'sentiment_very_satisfied',
        info: 'info',
        search: 'search',
        warningTriangle: 'warning',
        additionalInfo: 'additionalInfo'
    };

    constructor(private readonly _novaIconRegistry: NovaMatIconRegistryService) {}

    ngOnInit(): void {
        this._novaIconRegistry.addSvgIcon('surprised', 'assets/images/svg/surprise-regular.svg');
        this._novaIconRegistry.addSvgIcon('pointRight', 'assets/images/svg/point-right.svg');
        this._novaIconRegistry.addSvgIcon('additionalInfo', 'assets/images/svg/triangle_warning.svg');
    }

    onClose(): void {
        this.showBanner = false;
        this.close.emit();
    }
}
